export enum OnboardingStep {
  CreateLegalEntity = 'Create legal entity',
  CreateAccount = 'Create account',
  CreateMembership = 'Create membership',
  CreateWallet = 'Create wallet',
  CreateCompanyProfile = 'Create company profile',
  CreateLocation = 'Create location',
  PatchCompanyProfileMainLocation = 'Patch company profile main location',
  ActivateLegalEntity = 'Activate legal entity',
  FindAccountForRecovery = 'Find account for recovery',
  FindLegalEntityForRecovery = 'Find legal entity for recovery',
  FindInitialLegalEntity = 'Find initial legal entity',
}
